import cn from "classnames";

import { CheckActiveIcon } from "../AscIcons";
import styles from "./AscChallengePrompt.module.scss";

export interface AscChallengePromptProps {
  promptText: string;
  loading?: boolean;
  className?: string;
}

export default function AscChallengePrompt({
  promptText,
  loading = false,
  className,
}: AscChallengePromptProps) {
  return (
    <div
      className={cn(
        styles.promptCard,
        { [styles.loading]: loading },
        className
      )}
    >
      <CheckActiveIcon className={styles.promptCheckIcon} />
      <div
        className={styles.promptContent}
        dangerouslySetInnerHTML={{
          __html: `<b>Prompt text.</b> ${promptText}`,
        }}
      />
    </div>
  );
}
